import Hero from '../components/Hero';
import NetworkSection from '../components/NetworkSection';
import StatsSection from '../components/StatsSection';
import UpdatesSection from '../components/UpdatesSection';
import PromoSection from '../components/PromoSection';
import CtaSection from '../components/CtaSection';


export default function Home() {
  return (
    <>
      <Hero />
      <NetworkSection />
      <StatsSection />
      <UpdatesSection />
      <PromoSection
        eyebrow="Ecosystem"
        heading="The benchmark for onchain wallets."
        description="Discover the directory of onchain wallets that adhere to the highest UX standards and excel in security, features, and quality."
        buttonLabel="Learn More"
        buttonTo="/wallets"
      />
      <CtaSection />
    </>
  );
}